<template>
	<div>
		<div class="panel-header panel-header-custom bg-primary-gradient">
			<div class="page-inner py-5">
				<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
					<div>
						<h2 class="text-white pb-2 fw-bold">{{ $t('Добавить заявку по целевому гранту') }}</h2>
						<!-- <h5 class="text-white op-7 mb-2">Краткая статистика заявок приема</h5> -->
					</div>
					<div class="ml-md-auto py-2 py-md-0">

					</div>
				</div>
			</div>
		</div>
		<div class="page-inner mt--5">
			<v-stepper v-model="step" alt-labels>
				<v-stepper-header>
					<v-stepper-step :complete="step > 1" step="1">{{ $t('Тип заявки') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 1" step="2">{{ $t('Профдиагностика') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 2" step="3">{{ $t('Данные') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 3" step="4">{{ $t('Образование') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 4" step="5">{{ $t('Квота') }}</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="step > 5" step="6">{{ $t('Специальность') }}</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="1">
						<div v-if="metadataLoading" class="text-center py-8">
							<v-progress-circular indeterminate color="primary"></v-progress-circular>
						</div>
						<template v-else-if="metadataLoaded">
							<v-card
								v-for="(item, index) in applicationTypeCards"
								:key="'step1-' + index"
								outlined
								class="mb-4"
							>
								<v-card-text class="text-h6">
									{{ item.title }}<br>
									<div class="blue--text text-darken-3 font-weight-bold">{{ item.subtitle }}</div>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn depressed @click.stop="selectApplicationType(item)">{{ $t('Продолжить') }}</v-btn>
								</v-card-actions>
							</v-card>
						</template>
					</v-stepper-content>

					<v-stepper-content step="2">
						{{ $t('Пройдите профдиагностику на сайте') }} <a href="https://edunavigator.kz/" target="_blank" class="">BTS·Education</a>

						<v-checkbox v-model="btsCheckbox" :label="$t('Я получил(а) и ознакомился(ась) с результатами профдиагностики')"></v-checkbox>

						<div class="text-right">
							<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
							<v-btn color="primary" @click.stop="step3" :disabled="!btsCheckbox" :loading="isLoading">{{ $t('Далее') }}</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content step="3">
						<v-form class="form" ref="formStep3">
							<v-alert
									dense
									outlined
									type="info"
									class="mb-4"
							>
								<strong>{{ $t('Тип заявителя') }}:</strong> {{ declarantTypeLabel }}
							</v-alert>
							<template v-if="requestData.declarant_type_id">
								<v-card outlined class="mb-4">
									<v-card-title>{{ $t('Данные абитуриента') }}</v-card-title>
									<v-card-text>
										<v-row>
											<v-col sm="3" cols="12">
												<v-text-field
														v-model="requestData.surname"
														:label="$t('Фамилия')"
														type="text"
												></v-text-field>
											</v-col>
											<v-col sm="3" cols="12">
												<v-text-field
														v-model="requestData.name"
														:label="$t('Имя')"
														type="text"
														:rules="[v => !!v || $t('Обязательное поле')]"
														required
												></v-text-field>
											</v-col>
											<v-col sm="3" cols="12">
												<v-text-field
														v-model="requestData.lastname"
														:label="$t('Отчество')"
														type="text"
												></v-text-field>
											</v-col>
											<v-col sm="3" cols="12">
												<v-menu
														v-model="datePickerMenu"
														:close-on-content-click="false"
														:nudge-right="40"
														transition="scale-transition"
														offset-y
														min-width="auto">
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
																v-model="requestData.birthday"
																:label="$t('Дата рождения')"
																readonly
																prepend-icon="mdi-calendar"
																:rules="birthdayDateRules"
																required
																v-bind="attrs"
																v-on="on"
														></v-text-field>
													</template>
													<v-date-picker
															v-model="requestData.birthday"
															min="1901-01-01"
															:max="maxBirthdayDate"
															@input="datePickerMenu = false"
													></v-date-picker>
												</v-menu>
											</v-col>
										</v-row>
										<v-row>
											<v-col sm="4" cols="12">
												<v-select
														v-model="requestData.citizen_status_id"
														:items="citizenStatusList"
														item-text="name"
														item-value="id"
														:rules="[v => !!v || $t('Обязательное поле')]"
														:label="$t('Статус гражданина')">
												</v-select>
											</v-col>
											<v-col sm="4" cols="12">
												<v-select
														v-model="requestData.nationality_id"
														:items="nationalityList"
														item-text="name"
														item-value="id"
														:rules="[v => !!v || $t('Обязательное поле')]"
														:label="$t('Национальность')">
												</v-select>
											</v-col>
											<v-col sm="4" cols="12">
												<v-text-field
														v-model="requestData.iin"
														:label="$t('ИИН')"
														type="number"
														:rules="[v => !v || v.match(/\d/g).length === 12 || $t('Неправильный формат ИИН')]"
														@wheel="$event.target.blur()"
												></v-text-field>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>

								<v-card outlined class="mb-4">
									<v-card-title>{{ $t('Контактные данные') }}</v-card-title>
									<v-card-text>
										<v-row>
											<v-col sm="4" cols="12">
												<v-text-field
														v-model="requestData.email"
														:label="$t('Электронная почта')"
														type="text"
														:rules="[v => !!v || $t('Обязательное поле'), v => /.+@.+\..+/.test(v) || $t('Введите корректный E-mail')]"
														required
												></v-text-field>
											</v-col>
											<v-col sm="4" cols="12">
												<v-text-field
														v-model="requestData.phone_number"
														:label="$t('Номер телефона абитуриента')"
														prefix="+"
														type="number"
														@wheel="$event.target.blur()"
														:rules="[v => !!v || $t('Обязательное поле'), v => !v || v.match(/\d/g).length === 11 || $t('Неправильный формат телефона')]"
														required
												></v-text-field>
											</v-col>
											<v-col sm="4" cols="12">
												<v-text-field
														v-model="requestData.parent_phone_number"
														:label="$t('Номер телефона родителя')"
														type="number"
														prefix="+"
														@wheel="$event.target.blur()"
														:rules="[v => !!v || $t('Обязательное поле'), v => !v || v.match(/\d/g).length === 11 || $t('Неправильный формат телефона')]"
														required
												></v-text-field>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>

								<v-card outlined class="mb-4">
									<v-card-title>{{ fileSectionTitle('Медицинские данные') }}</v-card-title>
									<v-card-text>
										<v-row>
											<v-col sm="12" cols="12">
												<v-file-input
														:label="$t('Медицинская справка 075/У (086)')"
														accept="image/*,application/pdf"
														:rules="[requiredFileRule, fileSizeRule]"
														@change="form086ToBase64"
														required >
												</v-file-input>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>

								<v-row>
									<v-col>
										<v-checkbox v-model="requestData.instructionCheck" :label="$t('С Единой инструкцией по проведению Конкурса ознакомлен(-а)')" :rules="[v => !!v || $t('Обязательное поле')]"></v-checkbox>
									</v-col>
									<v-col>
										<v-checkbox v-model="requestData.personalDataCheck" :label="$t('Даю согласие на сбор, обработку персональных данных')" :rules="[v => !!v || $t('Обязательное поле')]"></v-checkbox>
									</v-col>
								</v-row>
								
								
							</template>
						</v-form>

						<div class="text-right">
							<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
							<v-btn color="primary" @click.stop="step4" :loading="isLoading">{{ $t('Далее') }}</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content step="4">
						<v-form class="form" ref="formStep4">
							<v-select
									v-model="requestData.education_type_id"
									:items="educationTypeList"
									item-text="name"
									item-value="id"
									:rules="[v => !!v || $t('Обязательное поле')]"

									:label="$t('Тип образования')">
							</v-select>

							<template v-if="requestData.education_type_id">
								<v-card outlined class="mb-4" v-if="requestData.education_type_id == 1 || requestData.education_type_id == 2">
									<v-card-title>{{ $t('Данные о школе') }}</v-card-title>
									<v-card-text>

										<v-autocomplete
												v-model="requestData.school_country_id"
												:items="countryList"
												item-text="name"
												item-value="id"
												:label="$t('Страна')"
												clearable
												:rules="[v => !!v || $t('Обязательное поле')]">
										</v-autocomplete>
										<template v-if="isDomesticSchoolCountry">
											<v-select
													v-model="requestData.school_region_ab"
													:items="regionList"
													item-text="name"
													:item-value="schoolRegionItemValue"
													:rules="[v => !!v || $t('Обязательное поле')]"
													:label="$t('Регион')">
											</v-select>
											<v-autocomplete
													:key="'school-' + requestData.school_region_ab"
													v-model="requestData.school_id"
													:items="schoolList"
													item-text="name"
													item-value="id"
													:label="$t('Школа')"
													clearable
													:rules="[schoolIdRule]">
											</v-autocomplete>
										</template>


									</v-card-text>
								</v-card>
								<v-text-field
										v-model="requestData.graduation_year"
										:label="$t('Год окончания')"
										type="text"
										inputmode="numeric"
										maxlength="4"
										@input="onGraduationYearInput"
										:rules="graduationYearRules"
										required
								></v-text-field>

								<v-select
										v-model="requestData.education_document_type_id"
										:items="educationDocumentList"
										item-text="name"
										item-value="id"
										:rules="[v => !!v || $t('Обязательное поле')]"
										:label="$t('Тип документа')">
								</v-select>

								<v-card outlined class="mb-4">
									<v-card-title>{{ fileSectionTitle('Документ об образовании') }}</v-card-title>
									<v-card-text>
										<v-file-input
												:label="$t('Документ об образовании')"
												accept="image/*,application/pdf"
												:rules="[requiredFileRule, fileSizeRule]"
												@change="educationDocumentToBase64"
												required >
										</v-file-input>
									</v-card-text>
								</v-card>
							</template>
						</v-form>
						<div class="text-right">
							<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
							<v-btn color="primary" @click.stop="step5" :loading="isLoading">{{ $t('Далее') }}</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content step="5">
						<v-form class="form" ref="formStep5">
							<v-select
									v-model="requestData.quota_list[0].id"
									:items="quotaCategoryList"
									@change="quotaCategoryChanged"
									item-text="name"
									item-value="id"
									:rules="[v => !!v || $t('Обязательное поле')]"
									:label="$t('Тип льготы')">
							</v-select>
							<template v-if="requestData.quota_list[0].id && requestData.quota_list[0].id != 0 && requestData.quota_list[0].id != 3">
								<v-card outlined class="mb-4">
									<v-card-title>{{ fileSectionTitle('Документ подтверждающий льготу') }}</v-card-title>
									<v-card-text>
										<v-file-input
												:label="$t('Документ подтверждающий льготу')"
												accept="image/*,application/pdf"
												:rules="[requiredFileRule, fileSizeRule]"
												@change="quotaDocumentToBase64"
												required >
										</v-file-input>
									</v-card-text>
								</v-card>
							</template>
						</v-form>
						<div class="text-right">
							<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0">{{ $t('Назад') }}</v-btn>
							<v-btn color="primary" @click.stop="step6" :loading="isLoading">{{ $t('Далее') }}</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content step="6">
						<v-form class="form" ref="formStep6">
							<v-select
									v-model="requestData.education_form_id"
									:items="educationFormList"
									@change="clearQualificationList"
									item-text="name"
									item-value="id"
									:rules="[v => !!v || $t('Обязательное поле')]"
									:label="$t('Форма обучения')">
							</v-select>
							<v-select
									v-model="requestData.region_ab"
									:items="regionIsEdusList"
									@change="clearQualificationList"
									item-text="name"
									:item-value="schoolRegionItemValue"
									:rules="[v => !!v || $t('Обязательное поле')]"
									:label="$t('Регион')">
							</v-select>
							<div
								v-if="requestData.region_ab && requestData.education_form_id"
								:key="'qualifications-' + requestData.region_ab + '-' + requestData.education_form_id"
							>
								<v-card outlined class="mb-4" v-for="(item, index) in requestData.choosed_qualification" :key="'qualification-' + index">
									<v-card-text>
										<v-btn fab small depressed text v-if="index != 0" @click.stop="removeQualificationBlock(index)" style="position: absolute; top: 0; right: 0;">
											<v-icon>mdi-close</v-icon>
										</v-btn>
										<v-autocomplete
												v-model="qualificationSelected[index]"
												:items="qualificationList"
												item-value="qualification_code"
												:label="$t('Специальность №')+(index+1)"
												@change="qualificationChanged($event, index)"
												clearable
												:filter="customQualificationFilter"
												:rules="[v => !v || Object.keys(v).length != 0 || $t('Обязательное поле')]"
												return-object>
											<template v-slot:item="{ item }">
												<div class="py-3">
													{{ item.display_label }}
												</div>
											</template>
											<template v-slot:selection="{ item }">
											<span style="text-overflow: ellipsis; overflow: hidden; width: 90%; white-space: nowrap; position: absolute;">
												{{ item.display_label }}
											</span>
											</template>
										</v-autocomplete>

										<v-select
											v-if="qualificationSelected[index] && qualificationSelected[index].colleges"
											v-model="item.college_id"
											:items="collegeList[index]"
											@change="newApiCollegeChanged(index)"
											item-text="name"
											item-value="college_id"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Организация образования')">
										</v-select>
										<v-select
											v-if="item.college_id"
											v-model="item.lang"
											:items="collegeLangList[index]"
											@change="newApiLangChanged(index)"
											item-text="name"
											item-value="lang_short"
											:rules="[v => !!v || $t('Обязательное поле')]"
											:label="$t('Язык обучения')">
										</v-select>
										<v-checkbox
											v-if="item.lang && collegeTargetGrantList[index]"
											v-model="item.target_grant"
											:label="$t('Хочу участвовать в целевом гранте')"
										></v-checkbox>

									</v-card-text>
								</v-card>
								<v-btn color="primary" @click.stop="addQualificationBlock" v-if="requestData.payment_type_id == 2 && requestData.training_type_id == 1 && maxChoosedQualificationCoun > requestData.choosed_qualification.length">
									{{ $t('Добавить еще одну специальность') }}
								</v-btn>
							</div>

							<v-divider class="my-4"></v-divider>
							<sign-ecp @update-ecp-file-data="requestData.p12 = $event" @update-ecp-password="requestData.password = $event" />
						</v-form>
						<div class="text-right">
							<v-btn v-if="step != 1" @click.stop="step--" class="mr-3" elevation="0" :loading="isLoading">{{ $t('Назад') }}</v-btn>
							<v-btn color="primary" @click.stop="submitRequest" :loading="isLoading">{{ $t('Отправить') }}</v-btn>
						</div>
					</v-stepper-content>


				</v-stepper-items>
			</v-stepper>
		</div>
	</div>
</template>

<script>
	import {
		mapMetadataToSelectItems,
		buildStep1ApplicationTypes,
		getCollegeDeclarantTypeLabel,
		resolveCollegeDeclarantTypeId,
		buildDefaultEducationRelations,
		mapRelationsDocuments,
		mapQualificationApiResponse,
		buildQualificationFormBody,
		normalizeRegions,
		mapCollegeLangOptions,
		getCollegeLangTargetGrantAvailability,
	} from '@/utils/metadata';
	import { formatSchoolList } from '@/utils/format';
	import { buildAddOrderFormData, createBirthdayDateRules, formatMaxBirthdayDate } from '@/utils/orderForm';
	import { buildFileSectionTitle, createFileSizeRule } from '@/utils/fileUpload';

	export default {
		computed: {
			applicationTypeCards() {
				return buildStep1ApplicationTypes(this.metadata);
			},
			declarantTypeLabel() {
				return getCollegeDeclarantTypeLabel(this.metadata, this.requestData.declarant_type_id)
					|| this.$t('Приемная комиссия');
			},
			schoolRegionItemValue() {
				return 'id';
			},
			isDomesticSchoolCountry() {
				return Number(this.requestData.school_country_id) === 398;
			},
			graduationYearRules() {
				const currentYear = new Date().getFullYear();
				return [
					(v) => !!v || this.$t('Обязательное поле'),
					(v) => !v || /^\d{4}$/.test(String(v)) || this.$t('Неправильный формат'),
					(v) => !v || Number(v) >= 1901 || this.$t('Год не может быть меньше 1901'),
					(v) => !v || Number(v) <= currentYear || this.$t('Год не может быть больше текущего'),
				];
			},
			birthdayDateRules() {
				return createBirthdayDateRules((key) => this.$t(key));
			},
			maxBirthdayDate() {
				return formatMaxBirthdayDate();
			},
		},
		mounted() {
			this.loadMetadata();
		},
		data () {
			return {
				metadata: null,
				metadataLoaded: false,
				metadataLoading: false,
				isLoading: false,
				step: 1,
				btsCheckbox: false,
				declarantTypeList: [],
				citizenStatusList: [],
				educationTypeList: [],
				nationalityList: [],
				datePickerMenu: false,
				countryList: [],
				regionList: [],
				regionIsEdusList: [],
				schoolList: [],
				educationDocumentList: [],
				quotaCategoryList: [],
				educationFormList: [],
				qualificationList: [],
				qualificationSelected: [],
				collegeList: [],
				collegeLangList: [],
				collegeTargetGrantList: [],
				form086File: null,
				educationDocumentFile: null,
				quotaDocumentFile: null,
				choosedQualificationItem: {
					"specialty_code": null,
					"code": null,
					"bin": null,
					"lang": null,
					"college_id": null,
					"target_grant": false,
				},
				maxChoosedQualificationCoun: 4,

				requestData: {
					training_type_id: null,
					payment_type_id: null,
					declarant_type_id: null,
					citizen_status_id: null,
					surname: null,
					name: null,
					lastname: null,
					iin: null,
					birthday: null,
					nationality_id: null,
					graduation_year: null,
					education_type_id: null,
					school_country_id: 398,
					school_region_ab: null,
					school_id: null,
					education_document_type_id: null,
					education_document: null,
					is_have_quota: null, // TODO
					quota_list: [
						{
							"id": null,
							"document": null
						}
					],
					region_ab: null,
					education_form_id: null,
					choosed_qualification: [],
					p12: null,
					password: null,
				}
			}
		},
		methods: {
			requiredFileRule(value) {
				return !!value || this.$t('Обязательное поле');
			},
			fileSectionTitle(titleKey) {
				return buildFileSectionTitle((key) => this.$t(key), titleKey);
			},
			fileSizeRule(file) {
				return createFileSizeRule((key) => this.$t(key))(file);
			},
			onGraduationYearInput(value) {
				const digits = String(value || '').replace(/\D/g, '').slice(0, 4);
				this.requestData.graduation_year = digits === '' ? null : digits;
			},
			schoolIdRule(v) {
				if (v === 0 || v === '0' || v) {
					return true;
				}
				return this.$t('Обязательное поле');
			},
			selectApplicationType(item) {
				this.requestData.training_type_id = item.training_type_id;
				this.requestData.payment_type_id = item.payment_type_id;
				this.step++;
			},
			async loadMetadata(force = false) {
				if (this.metadataLoaded && !force) {
					return;
				}
				this.metadataLoading = true;
				try {
					const response = await this.$http.get('/metadata');
					this.metadata = response.data.data || response.data;
					this.metadataLoaded = true;
					this.applyMetadataLists();
				} catch (error) {
					console.error('Ошибка загрузки metadata:', error);
				} finally {
					this.metadataLoading = false;
				}
			},
			applyMetadataLists() {
				if (!this.metadata) {
					return;
				}
				this.citizenStatusList = mapMetadataToSelectItems(this.metadata.citizen_status);
				this.declarantTypeList = mapMetadataToSelectItems(this.metadata.declarant_type);
				this.educationTypeList = mapMetadataToSelectItems(this.metadata.education_type);
				this.educationFormList = mapMetadataToSelectItems(this.metadata.education_form);
			},
			applyEducationDocumentsFromMetadata() {
				const relations = buildDefaultEducationRelations(this.metadata);
				this.educationDocumentList = mapRelationsDocuments(
					relations,
					this.requestData.education_type_id
				);
				if (this.requestData.education_document_type_id) {
					const isValid = this.educationDocumentList.some(
						(item) => item.id === this.requestData.education_document_type_id
					);
					if (!isValid) {
						this.requestData.education_document_type_id = null;
					}
				}
			},
			prepareStep3() {
				this.applyMetadataLists();
				this.requestData.declarant_type_id = resolveCollegeDeclarantTypeId(this.metadata);
			},
			async reloadLocalizedListsOnLanguageChange() {
				this.metadataLoaded = false;
				this.metadata = null;
				await this.loadMetadata(true);
				if (this.nationalityList.length) {
					this.nationalityList = [];
					await this.getNationality(true);
				}
				if (this.regionList.length) {
					this.regionList = [];
					await this.getRegion(true);
				}
				if (this.requestData.school_region_ab) {
					await this.getSchool();
				}
				if (this.quotaCategoryList.length) {
					this.quotaCategoryList = [];
					await this.getQuotaCategory(true);
				}
				if (this.regionIsEdusList.length) {
					this.regionIsEdusList = [];
					await this.getRegionIsEdus(true);
				}
				if (this.qualificationList.length) {
					await this.getQualification();
				}
			},
			async step3() {
				if (!this.metadataLoaded) {
					await this.loadMetadata();
				}
				this.prepareStep3();
				await this.getNationality();
				this.step++;
			},
			async step4() {
				if(this.$refs.formStep3.validate()) {
					this.applyMetadataLists();
					this.step++;
				}
			},
			async step5() {
				if(this.$refs.formStep4.validate()) {
					await this.getQuotaCategory();
					this.step++;
				}
			},
			async step6() {
				if(this.$refs.formStep5.validate()) {
					if (!this.metadataLoaded) {
						await this.loadMetadata();
					} else {
						this.applyMetadataLists();
					}
					await this.getRegionIsEdus();
					this.step++;
				}
			}, 

			async getNationality(force = false) {
				if (this.nationalityList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/nationality');
					const data = response.data.data || response.data;
					this.nationalityList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getCountry(force = false) {
				if (this.countryList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/country');
					const data = response.data.data || response.data;
					this.countryList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getRegion(force = false) {
				if (this.regionList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/regions');
					const data = response.data.data || response.data;
					this.regionList = Array.isArray(data) ? data : [];
				} finally {
					this.isLoading = false;
				}
			},
			async getRegionIsEdus(force = false) {
				if (this.regionIsEdusList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/regions');
					const data = response.data.data || response.data;
					this.regionIsEdusList = normalizeRegions(data);
				} finally {
					this.isLoading = false;
				}
			},
			async getSchool() {
				const regionId = this.requestData.school_region_ab;
				if (!regionId) {
					this.schoolList = [];
					return;
				}
				this.isLoading = true;
				try {
					const body = new URLSearchParams();
					body.append('id', regionId);
					const response = await this.$http.post('/schools', body);
					const data = response.data.data || response.data;
					const schools = formatSchoolList(data);
					if (this.requestData.school_region_ab !== regionId) {
						return;
					}
					this.schoolList = schools;
					this.schoolList.push({
						id: '0',
						name: this.$t('Другое'),
					});
					if (this.schoolList.length === 1) {
						this.requestData.school_id = '0';
					}
				} catch (error) {
					if (this.requestData.school_region_ab === regionId) {
						this.schoolList = [];
					}
					console.error('Ошибка загрузки школ:', error);
				} finally {
					if (this.requestData.school_region_ab === regionId) {
						this.isLoading = false;
					}
				}
			},
			async getEducationDocument() {
				if (!this.metadataLoaded) {
					await this.loadMetadata();
				}
				this.applyEducationDocumentsFromMetadata();
			},
			async getQuotaCategory(force = false) {
				if (this.quotaCategoryList.length && !force) {
					return;
				}
				this.isLoading = true;
				try {
					const response = await this.$http.get('/quota');
					const data = response.data.data || response.data;
					this.quotaCategoryList = Array.isArray(data) ? [...data] : [];
					this.quotaCategoryList.unshift({
						id: '0',
						name: this.$t('Без льготы'),
					});
				} finally {
					this.isLoading = false;
				}
			},
			quotaCategoryChanged(v) {
				this.requestData.is_have_quota = v != 0;
				if(v == 0) {
					this.requestData.quota_list[0].document = null;
				}
			},

			clearQualificationList() {
				this.requestData.choosed_qualification = [];
				this.qualificationSelected = [];
				this.qualificationList = [];
				this.collegeList = [];
				this.collegeLangList = [];
				this.collegeTargetGrantList = [];
				this.addQualificationBlock();
				if(this.requestData.education_form_id && this.requestData.region_ab) {
					this.getQualification();
				}
			},
			addQualificationBlock() {
				this.qualificationSelected.push({});
				this.requestData.choosed_qualification.push(Object.assign({}, this.choosedQualificationItem));
			},
			customQualificationFilter(item, queryText) {
				const searchText = queryText.toLowerCase();
				const displayLabel = (item.display_label || '').toLowerCase();
				const name = (item.name || '').toLowerCase();
				const qualificationCode = (item.qualification_code || '').toLowerCase();
				const specialtyCode = (item.specialty_code || '').toLowerCase();
				return displayLabel.includes(searchText)
					|| name.includes(searchText)
					|| qualificationCode.includes(searchText)
					|| specialtyCode.includes(searchText);
			},
			removeQualificationBlock(index) {
				this.requestData.choosed_qualification.splice(index, 1); 
			},
			async getQualification() {
				const regionAb = this.requestData.region_ab;
				const educationFormId = this.requestData.education_form_id;
				if (!regionAb || !educationFormId) {
					this.qualificationList = [];
					return;
				}
				this.isLoading = true;
				try {
					const body = buildQualificationFormBody(this.requestData);
					const response = await this.$http.post('/qualification-list', body, {
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					});
					const data = response.data.data || response.data;
					const qualifications = mapQualificationApiResponse(data);
					if (this.requestData.region_ab !== regionAb
						|| this.requestData.education_form_id !== educationFormId) {
						return;
					}
					this.qualificationList = qualifications;
				} catch (error) {
					if (this.requestData.region_ab === regionAb
						&& this.requestData.education_form_id === educationFormId) {
						this.qualificationList = [];
					}
					console.error('Ошибка загрузки специальностей:', error);
				} finally {
					if (this.requestData.region_ab === regionAb
						&& this.requestData.education_form_id === educationFormId) {
						this.isLoading = false;
					}
				}
			},
			qualificationChanged(item, index) {
				this.requestData.choosed_qualification[index].bin = null;
				this.requestData.choosed_qualification[index].college_id = null;
				this.requestData.choosed_qualification[index].lang = null;
				this.requestData.choosed_qualification[index].target_grant = false;
				this.collegeList[index] = [];
				this.collegeLangList[index] = [];
				this.collegeTargetGrantList[index] = false;
				if (!item) {
					return;
				}
				this.requestData.choosed_qualification[index].specialty_code = item.specialty_code || '';
				this.requestData.choosed_qualification[index].code = item.qualification_code;
				this.collegeList[index] = item.colleges || [];
				if (item.colleges && item.colleges.length === 1) {
					this.requestData.choosed_qualification[index].college_id = item.colleges[0].college_id;
					this.newApiCollegeChanged(index);
				}
			},
			newApiCollegeChanged(index) {
				const selected = this.qualificationSelected[index];
				const collegeId = this.requestData.choosed_qualification[index].college_id;
				this.requestData.choosed_qualification[index].lang = null;
				this.requestData.choosed_qualification[index].bin = null;
				this.requestData.choosed_qualification[index].target_grant = false;
				this.collegeTargetGrantList[index] = false;
				if (!selected || !collegeId) {
					this.collegeLangList[index] = [];
					return;
				}
				const college = (selected.colleges || []).find((c) => c.college_id === collegeId);
				if (!college) {
					this.collegeLangList[index] = [];
					return;
				}
				this.requestData.choosed_qualification[index].bin = college.college_id;
				this.collegeLangList[index] = mapCollegeLangOptions(college.lang, this.metadata);
				if (college.lang && college.lang.length === 1) {
					this.requestData.choosed_qualification[index].lang = college.lang[0];
					this.newApiLangChanged(index);
				}
			},
			newApiLangChanged(index) {
				const selected = this.qualificationSelected[index];
				const chosen = this.requestData.choosed_qualification[index];
				chosen.target_grant = false;
				this.collegeTargetGrantList[index] = false;
				if (!selected || !chosen.college_id || !chosen.lang) {
					return;
				}
				const college = (selected.colleges || []).find((c) => c.college_id === chosen.college_id);
				if (!college) {
					return;
				}
				const isAvailable = getCollegeLangTargetGrantAvailability(college, chosen.lang);
				this.collegeTargetGrantList[index] = isAvailable;
				if (isAvailable) {
					chosen.target_grant = true;
				}
			},
			form086ToBase64(file) {
				this.form086File = file || null;
			},
			educationDocumentToBase64(file) {
				this.educationDocumentFile = file || null;
			},
			quotaDocumentToBase64(file) {
				this.quotaDocumentFile = file || null;
			},
			async submitRequest() {
				if (!this.$refs.formStep6.validate()) {
					return;
				}
				this.isLoading = true;
				try {
					const formData = buildAddOrderFormData(
						this.requestData,
						this.qualificationSelected,
						{
							form086File: this.form086File,
							educationDocumentFile: this.educationDocumentFile,
							quotaDocumentFile: this.quotaDocumentFile,
						},
						{
							includeIsTargetGrant: true,
							regionList: this.regionList,
						}
					);
					const response = await this.$http.post('/add-order', formData);
					const message = response.data.message || this.$t('Заявка успешно отправлена');
					this.$store.dispatch('alertAdd', { text: message, type: 'success' });
					const orderId = response.data.data && response.data.data.id;
					if (orderId) {
						this.$router.push({ path: '/college/request/' + orderId });
					}
				} catch (error) {
					console.error('Ошибка отправки заявки:', error);
				} finally {
					this.isLoading = false;
				}
			}
		},
		watch:{
			'$store.state.language': function () {
				this.reloadLocalizedListsOnLanguageChange();
			},
			'requestData.training_type_id': function () {
				this.requestData.education_form_id = null;
				this.requestData.region_ab = null;

				this.clearQualificationList();
			},
			'requestData.payment_type_id': function () {
				this.clearQualificationList();
			},
			'requestData.declarant_type_id': function (v) {
				if(v == 1) {
					this.requestData.surname = this.$store.getters.getAbiturientInfo.surname || '';
					this.requestData.name = this.$store.getters.getAbiturientInfo.name || '';
					this.requestData.lastname = this.$store.getters.getAbiturientInfo.lastname || '';
					this.requestData.birthday = this.$store.getters.getAbiturientInfo.birthDate || '';
					this.requestData.iin = this.$store.getters.getAbiturientInfo.iin || '';
					this.requestData.email = this.$store.getters.getAbiturientInfo.email || '';
				}
			},
			'requestData.education_type_id': function (v) {
				if(v == 1 || v == 2) {
					if (!this.requestData.school_country_id) {
						this.requestData.school_country_id = 398;
					}
					this.getCountry();
					this.getRegion();
				} else {
					this.requestData.school_region_ab = null;
					this.requestData.school_id = null;
				}
				this.requestData.education_document_type_id = null;
				this.getEducationDocument();
			},
			'requestData.school_country_id': function (v) {
				if (Number(v) !== 398) {
					this.requestData.school_region_ab = null;
					this.requestData.school_id = null;
				}
			},
			'requestData.school_region_ab': function () {
				this.requestData.school_id = null;
				this.schoolList = [];
				this.getSchool();
			}
		}
	}
</script>